import React from "react"
import { FormattedMessage } from "react-intl"
import Integrations from "../../../integration/Integrations"
import { EventObjectDto } from "../../../state/event/Event"
import { INTEGRATION_KEY } from "../../../state/integration/Constants"
import Proposal from "../../../state/proposal/Proposal"
import { QuoteDto } from "../../../state/quote/Quote"

type OwnProps = {
    object: EventObjectDto
    quote: QuoteDto
    proposal: Proposal
}

const QuoteExportedToZendeskSupportEvent = (props: OwnProps) => {
    const Url = Integrations.getExternalOrderUrl(props.object)

    return (
        <div className={"row"}>
            <div className={"col-12"}>
                <p className={"mb-2"} data-document-event="quote-exported">
                    <FormattedMessage
                        id="quote.analytics.events.exported.zendesk_support.text"
                        defaultMessage="Quote {identifier} has been exported to Zendesk Support, ticket #{externalId}"
                        values={{
                            identifier: <strong>{props.quote.attributes.identifier}</strong>,
                            externalId:  props.object.attributes.externalId,
                        }}
                    />
                </p>
            </div>

            <div className={"col-12 d-flex align-items-center flex-wrap"}>
                <div className={"mr-3"}>
                    <a href={Url} target="_blank" rel="noreferrer">
                        {Integrations.getIntegrationLogoImage(INTEGRATION_KEY.ZENDESK_SUPPORT, 80, 21)}
                    </a>
                </div>
                {Url &&
                    <div className={""}>
                        <p className={"mb-0"}>
                            <a href={Url} target={"_blank"} className={"btn btn-sm btn-outline-primary"} rel="noreferrer">
                                <FormattedMessage
                                    id="invoice.analytics.events.exported.zendesk_support.open"
                                    defaultMessage="Open ticket in Zendesk support"
                                />
                            </a>
                        </p>
                    </div>
                }
            </div>
        </div>
    )
}
export default QuoteExportedToZendeskSupportEvent


// WEBPACK FOOTER //
// ./src/quote/analytics/events/quote-exported-zendesk-support.component.tsx